import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {

  connect() {
    // Enable footer navigation when this controller is connected.
    // This happens on initial page load and also whenever a file is finished being uploaded.
    document.querySelectorAll('[data-footer] button').forEach((button) => {
      button.disabled = false;
    });

    this.element.addEventListener("submit", this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    // Disable footer navigation while the file is uploading.
    document.querySelectorAll('[data-footer] button').forEach((button) => {
      button.disabled = true;
    });
  }

}